import { IconProps } from "./Icon.model";

export function SidebarIcon({ size = 16, fill = "currentColor" }: IconProps) {
  const fillColor =
    fill === "currentColor" ? "var(--slate-11)" : `var(--${fill}-8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.75 6.75C0.75 4.29058 0.75 3.06087 1.29254 2.18918C1.49327 1.86668 1.7426 1.58618 2.02927 1.36036C2.8041 0.75 3.89718 0.75 6.08333 0.75H8.75C10.9362 0.75 12.0292 0.75 12.8041 1.36036C13.0907 1.58618 13.3401 1.86668 13.5408 2.18918C14.0833 3.06087 14.0833 4.29058 14.0833 6.75C14.0833 9.20942 14.0833 10.4391 13.5408 11.3108C13.3401 11.6333 13.0907 11.9138 12.8041 12.1396C12.0292 12.75 10.9362 12.75 8.75 12.75H6.08333C3.89718 12.75 2.8041 12.75 2.02927 12.1396C1.7426 11.9138 1.49327 11.6333 1.29254 11.3108C0.75 10.4391 0.75 9.20942 0.75 6.75Z"
        stroke={fillColor}
        strokeWidth="1.5"
      />
      <path
        d="M9.08594 0.75L9.08594 12.75"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M11.418 3.41699H12.0846M11.418 5.41699H12.0846"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}


